export const itemCategoryOptions = [
  { id: "accessories", displayName: "Accessoires" },
  { id: "bags", displayName: "Sacs" },
  { id: "bottoms", displayName: "Bas" },
  { id: "dresses-jumpsuits", displayName: "Robes/combinaisons" },
  { id: "outerwear", displayName: "Vestes/manteaux" },
  { id: "shoes", displayName: "Chaussures" },
  { id: "tops", displayName: "Tops" },
];

export const repairTypeOptions = [
  { id: "belt-loop", displayName: "Passant de ceinture" },
  { id: "button-stud", displayName: "Bouton/clou" },
  { id: "crotch-repair", displayName: "Réparation de l'entrejambe" },
  { id: "hem", displayName: "Ourlet" },
  { id: "hole", displayName: "Trou" },
  { id: "pocket", displayName: "Poche" },
  { id: "tear-seam", displayName: "Déchirures/coutures" },
  { id: "zip", displayName: "Fermeture éclair" },
];
